module.exports = __webpack_public_path__ + "img/khalBanner.c9e4f39a.png";